module.exports = __webpack_public_path__ + "img/sidecar.233850bc.jpg";